import { cn } from "@/lib/utils";

interface DemoBadgeProps {
  label: string;
  className?: string;
}

export function DemoBadge({ label, className }: DemoBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-sm border border-sun/40 bg-sun/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-ridge",
        className,
      )}
    >
      {label}
    </span>
  );
}
